
import { Component, Vue } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
@Component({
	components: { FontAwesomeIcon }
})
export default class IdentityVerificationHeader extends Vue {}
